import * as yup from "yup";
import { ContentBlockData, ContentBlockSchema } from "./";

export interface ContentCarouselData extends ContentBlockData {
    slides: ContentCarouselSlideData[];
    slideSpeed: number;
}

export interface ContentCarouselSlideData {
    delete: boolean;
    description?: string;
    id: number;
    image?: string;
    sort: number;
    index: number;
}

export const ContentCarouselSchema = yup.object().shape({
    slides: yup.array().of(yup.object<ContentCarouselSlideData>().shape({
        delete: yup.bool(),
        description: yup.string().max(4000).label("Description"),
        id: yup.number().when("delete", { is: false, then: yup.number().required() }),
        image: yup.string().when("delete", { is: false, then: yup.string().required().max(255) }).label("Image"),
        sort: yup.number().when("delete", { is: false, then: yup.number().required().min(1) }).label("Sequence"),
        index: yup.number(),
    })),
    slideSpeed: yup.number().required(),
}).concat(ContentBlockSchema);



// WEBPACK FOOTER //
// ./src/forms/adminPage/ContentCarousel.ts